import { Box, Container } from "@sembark-travel/ui/base"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import { AddCabPriceCalculationMetric } from "../../../CabPriceCalculationMetrics"
import { useNavigate, generatePath } from "../../../router-utils"

export default function CreateCabPriceCalculationMetricPage() {
	const navigate = useNavigate()
	const listUrl = generatePath("/cab-price-calculation-metrics")
	function navigateToList() {
		return navigate("/cab-price-calculation-metrics")
	}
	return (
		<>
			<Helmet>
				<title>Add Cab Price Calculation Metric</title>
			</Helmet>
			<Breadcrumbs
				title="Add Metric"
				items={[
					[listUrl, "Metrics"],
					["", "New"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="4xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<AddCabPriceCalculationMetric
								onSuccess={navigateToList}
								onCancel={navigateToList}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
